import { useLocation } from "react-router";
import CTAButton from "../SHARED/CTAButton";
import coreManImg from "../../Images/CoreGuyNoShins.jpg";
import CoreBikeManMobile from "../../Images/CoreBikeManMobile.jpg";
import { HashLink } from "react-router-hash-link";

const VelosurePerformance = () => {
  const infoIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="17"
      viewBox="0 0 24 17"
    >
      <circle
        id="Ellipse_81"
        data-name="Ellipse 81"
        cx="8"
        cy="8"
        r="8"
        transform="translate(8 1)"
        fill="#00a8ff"
      />
      <text
        id="i"
        transform="translate(14 13)"
        fill="#fff"
        fontSize="10"
        fontFamily="SegoeUI, Segoe UI"
      >
        <tspan x="1" y="0">
          i
        </tspan>
      </text>
    </svg>
  );
  const { search } = useLocation();
  return (
    <div className="container-fluid greyBG  pr oh mb-5 ">
      <div className="container mt-5 mb-5">
        <img src={coreManImg} className="coreManImg d-none d-md-block" alt="" />
        <div className="row">
          <div className="col-12 col-xl-8">
            <h3 className="lufga-medium font-44">
              Velosure <span className="blueFont">Performance</span>.
            </h3>
            <p className="blueFont font-23 lufga-medium">
              Powerful cover for serious cyclists
            </p>
            <p className="font-17">
              If you’re a road racer, mountain biker or cyclocross champ, our
              Performance policy may be more suited to you. You’ll be insured
              for your adventures away, whether you’re travelling to Europe or
              planning on cycling further afield*, as well as organised racing
              events and amateur competitions.{" "}
            </p>
            <p className="font-17">
              If all you want to worry about is your performance, look no
              further, this policy has you covered.{" "}
            </p>
            <img
              src={CoreBikeManMobile}
              alt="Man with performance racing bike"
              className="d-block d-md-none coreBikeManMobile"
            />

            <h3 className="lufga-medium font-35 mt-4">
              Key elements{" "}
              <span className="blueFont">included in Performance</span>.
            </h3>
          </div>
          {/* hide this version for mobile */}
          <div className="d-none d-md-block col-xl-8">
            <div className="row">
              <div className="col-6 col-lg-6">
                <article className="bikeBucket mb-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="135"
                    height="135"
                    viewBox="0 0 135 135"
                    className="CoreIcon"
                  >
                    <defs>
                      <filter
                        id="Rectangle_748"
                        x="0"
                        y="0"
                        width="135"
                        height="135"
                        filterUnits="userSpaceOnUse"
                      >
                        <feOffset dy="2" input="SourceAlpha" />
                        <feGaussianBlur stdDeviation="1.5" result="blur" />
                        <feFlood floodOpacity="0.2" />
                        <feComposite operator="in" in2="blur" />
                        <feComposite in="SourceGraphic" />
                      </filter>
                      <clipPath id="clipPath">
                        <rect
                          id="Rectangle_972"
                          data-name="Rectangle 972"
                          width="69.557"
                          height="77.12"
                          fill="#fff"
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Group_1808"
                      data-name="Group 1808"
                      transform="translate(-401.5 -727.5)"
                    >
                      <g
                        id="Group_1795"
                        data-name="Group 1795"
                        transform="translate(0 55)"
                      >
                        <g id="Group_1789" data-name="Group 1789">
                          <g
                            transform="matrix(1, 0, 0, 1, 401.5, 672.5)"
                            filter="url(#Rectangle_748)"
                          >
                            <rect
                              id="Rectangle_748-2"
                              data-name="Rectangle 748"
                              width="126"
                              height="126"
                              rx="32"
                              transform="translate(4.5 2.5)"
                              fill="#00a8ff"
                            />
                          </g>
                        </g>
                        <g
                          id="Group_2186"
                          data-name="Group 2186"
                          transform="translate(429.222 699.44) scale(1.6)"
                        >
                          <path
                            id="Path_2085"
                            dataname="Path 20885"
                            d="M48.841,32.139H34.091V20.04a1.148,1.148,0,0,0-1.148-1.148H31.1V15.817a.8.8,0,0,0-.8-.8H27.564V11.4a.78.78,0,0,0-.009-.087A4.552,4.552,0,0,0,28.99,9.406a.784.784,0,0,0,.094-.073c4.269-4.091,4.789-4.571,4.847-4.624.015-.012.029-.026.043-.04A2.213,2.213,0,0,0,32.42.883H30.208A.8.8,0,0,0,29.41,0H20.578a.8.8,0,0,0-.8.883H17.568a2.214,2.214,0,0,0-1.554,3.786c.014.014.028.028.043.04.058.052.577.532,4.848,4.624a.809.809,0,0,0,.089.07,4.55,4.55,0,0,0,1.438,1.914.758.758,0,0,0-.009.085v3.612H19.7a.8.8,0,0,0-.8.8v3.074H17.046A1.148,1.148,0,0,0,15.9,20.04v6.8H1.148A1.148,1.148,0,0,0,0,27.988v21.2a1.148,1.148,0,0,0,1.148,1.148H48.841a1.148,1.148,0,0,0,1.148-1.148v-15.9a1.148,1.148,0,0,0-1.148-1.148M33.023,3.094a.609.609,0,0,1-.181.435l.006.006c-.323.28-1.117,1.035-3.365,3.188l.527-4.232h2.41a.6.6,0,0,1,.6.6m-16.056,0a.6.6,0,0,1,.6-.6h2.409L20.5,6.72c-2.246-2.151-3.039-2.906-3.362-3.185l.007-.006a.609.609,0,0,1-.181-.435m4.522-1.486H28.5l-.8,6.438a2.9,2.9,0,0,1-1.9,2.422,2.581,2.581,0,0,1-1.617,0,2.9,2.9,0,0,1-1.9-2.422Zm2.544,10.485a4.132,4.132,0,0,0,1.925,0v2.922H24.032ZM20.5,16.621H29.49v2.27H20.5ZM2.3,29.137H15.9v18.9H2.3Zm15.9-7.949h13.6V48.036h-13.6Zm29.5,26.848h-13.6v-13.6h13.6Z"
                            transform="translate(0 0)"
                            fill="#fff"
                          />
                          <path
                            id="Path_2086"
                            dataname="Path 2086"
                            d="M53.163,61.136a1.226,1.226,0,0,0-.687-.2.775.775,0,0,0-.419.1l-1.909,1.157a.825.825,0,0,0-.419.767,1.022,1.022,0,0,0,.2.621.607.607,0,0,0,.505.274.639.639,0,0,0,.362-.116l.419-.26v7.36a.558.558,0,0,0,.333.513,1.836,1.836,0,0,0,1.59,0,.56.56,0,0,0,.333-.513v-9.2a.594.594,0,0,0-.311-.506"
                            transform="translate(-26.888 -32.945)"
                            fill="#fff"
                          />
                          <path
                            id="Path_2087"
                            dataname="Path 2087"
                            d="M18.516,81.1H14.692v-.132a1.126,1.126,0,0,1,.47-.77,10.291,10.291,0,0,1,1.132-.858q.664-.44,1.319-.967a4.867,4.867,0,0,0,1.122-1.3,3.167,3.167,0,0,0,.466-1.656,2.575,2.575,0,0,0-1.02-2.144,3.747,3.747,0,0,0-2.372-.8,3.612,3.612,0,0,0-2.289.761,2.438,2.438,0,0,0-.973,2.023q0,1.174,1,1.174a1.325,1.325,0,0,0,.852-.255.751.751,0,0,0,.322-.6,1.085,1.085,0,0,1,.309-.858,1.156,1.156,0,0,1,.793-.271,1.022,1.022,0,0,1,1.117,1.04,1.626,1.626,0,0,1-.478,1.056,6.967,6.967,0,0,1-1.169,1.041l-1.331,1A5.568,5.568,0,0,0,12.838,79.7a2.1,2.1,0,0,0-.465,1.255v1.416a.588.588,0,0,0,.325.5,1.241,1.241,0,0,0,.661.2H18.52a.577.577,0,0,0,.478-.3,1.227,1.227,0,0,0,.2-.7,1.15,1.15,0,0,0-.2-.681.585.585,0,0,0-.481-.29"
                            transform="translate(-6.69 -39.182)"
                            fill="#fff"
                          />
                          <path
                            id="Path_2088"
                            dataname="Path 2088"
                            d="M83.579,81.716a1.266,1.266,0,0,0,.825-.2.763.763,0,0,0,.23-.6.607.607,0,0,1,.257-.557,1.53,1.53,0,0,1,.8-.162.919.919,0,0,1,1.057,1.022,2.045,2.045,0,0,1-.093.673.656.656,0,0,1-.272.369,1.135,1.135,0,0,1-.341.142,1.989,1.989,0,0,1-.407.035c-.427,0-.642.288-.642.863s.214.863.641.863a1.816,1.816,0,0,1,1.022.237,1.026,1.026,0,0,1,.351.912v.274a1.389,1.389,0,0,1-.294,1,1.42,1.42,0,0,1-1.023.295q-1.273,0-1.272-.833a.659.659,0,0,0-.24-.583,1.751,1.751,0,0,0-.92-.166,1.47,1.47,0,0,0-.838.173.764.764,0,0,0-.232.647A2.557,2.557,0,0,0,83.054,88a3.557,3.557,0,0,0,2.566.835,4.11,4.11,0,0,0,2.633-.792,2.945,2.945,0,0,0,1-2.458v-.274A2.075,2.075,0,0,0,87.79,83.2a1.717,1.717,0,0,0,.819-.884,3.411,3.411,0,0,0,.3-1.454q0-2.622-3.214-2.623a3.436,3.436,0,0,0-2.486.783,2.445,2.445,0,0,0-.8,1.79.945.945,0,0,0,.21.726,1.659,1.659,0,0,0,.963.18"
                            transform="translate(-44.438 -42.3)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                  <h4 className="CoreIconLabels">Sports & events</h4>
                  <p className="font-16 coreIconText">
                    Your covered for participation in competitive road racing,
                    mountain biking, triathlons, duathlons and more!
                  </p>
                </article>
              </div>
              <div className="col-6 col-lg-6">
                <article className="bikeBucket text-left mb-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="135"
                    height="135"
                    viewBox="0 0 135 135"
                    className="CoreIcon"
                  >
                    <defs>
                      <filter
                        id="Rectangle_748"
                        x="0"
                        y="0"
                        width="135"
                        height="135"
                        filterUnits="userSpaceOnUse"
                      >
                        <feOffset dy="2" input="SourceAlpha" />
                        <feGaussianBlur stdDeviation="1.5" result="blur" />
                        <feFlood floodOpacity="0.2" />
                        <feComposite operator="in" in2="blur" />
                        <feComposite in="SourceGraphic" />
                      </filter>
                      <clipPath id="clipPath">
                        <rect
                          id="Rectangle_972"
                          data-name="Rectangle 972"
                          width="69.557"
                          height="77.12"
                          fill="#fff"
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Group_1808"
                      data-name="Group 1808"
                      transform="translate(-401.5 -727.5)"
                    >
                      <g
                        id="Group_1795"
                        data-name="Group 1795"
                        transform="translate(0 55)"
                      >
                        <g id="Group_1789" data-name="Group 1789">
                          <g
                            transform="matrix(1, 0, 0, 1, 401.5, 672.5)"
                            filter="url(#Rectangle_748)"
                          >
                            <rect
                              id="Rectangle_748-2"
                              data-name="Rectangle 748"
                              width="126"
                              height="126"
                              rx="32"
                              transform="translate(4.5 2.5)"
                              fill="#00a8ff"
                            />
                          </g>
                        </g>
                        <g
                          id="Group_2186"
                          data-name="Group 2186"
                          transform="translate(424.222 699.44) scale(1.4)"
                        >
                          <path
                            id="Path_2181"
                            dataname="Path 2181"
                            d="M63.851,63.9a6.715,6.715,0,0,1,2.3-5.064.808.808,0,0,0-.477-1.416.78.78,0,0,0-.585.2A8.331,8.331,0,0,0,62.233,63.9a8.2,8.2,0,1,0,8.2-8.275.809.809,0,0,0,0,1.618A6.657,6.657,0,1,1,63.851,63.9"
                            transform="translate(-23.519 -21.022)"
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth="0.05"
                          />
                          <path
                            id="Path_2182"
                            dataname="Path 2182"
                            d="M58.111,64.58H52.639a11.159,11.159,0,0,0-5.725-20.665,10.914,10.914,0,0,0-2.88.385L41.59,37.263a.673.673,0,0,0-.038-.114l-1.514-4.362a.848.848,0,0,0-.065-.145.78.78,0,0,0-.24-.267.809.809,0,0,0-.321-.134.774.774,0,0,0-.156-.013h-5.9a2.143,2.143,0,0,0,0,4.285.809.809,0,0,0,0-1.617.525.525,0,0,1,0-1.051h5.339l1.1,3.169L21.648,44.908l-2.731-3.916h2.176a.321.321,0,0,1,.315.327.809.809,0,0,0,1.617,0,1.941,1.941,0,0,0-1.932-1.944H15a1.919,1.919,0,0,0-1.933,1.944A1.941,1.941,0,0,0,15,43.262a.809.809,0,0,0,0-1.617.321.321,0,0,1-.315-.326A.307.307,0,0,1,15,40.992h1.943l3.38,4.847-.964.935a10.924,10.924,0,0,0-7.377-2.86A11.159,11.159,0,0,0,6.263,64.58H.809a.809.809,0,0,0,0,1.618H11.986a11.014,11.014,0,0,0,10.68-8.315l3.75.7a3.664,3.664,0,1,0,.3-1.59l-3.756-.7a11.4,11.4,0,0,0,.068-1.236,11.186,11.186,0,0,0-2.547-7.112l.785-.761,4.981,7.141A.808.808,0,1,0,27.57,53.4l-4.977-7.138,17.732-7.714.435,1.257L32.076,53.691a.809.809,0,1,0,1.372.858l7.995-12.784,1.067,3.074a11.159,11.159,0,0,0,4.4,21.358h11.2a.809.809,0,0,0,0-1.618M47.179,55.82a.809.809,0,0,0,.5-1.03l-3.112-8.959a9.3,9.3,0,0,1,2.347-.3,9.447,9.447,0,1,1-3.871.841l3.107,8.949a.807.807,0,0,0,1.029.5M19.313,49.075a9.581,9.581,0,0,1,2.1,5.981c0,.31-.016.625-.046.937L13.67,54.549Zm-7.882,5.394a.79.79,0,0,0-.156.2.776.776,0,0,0-.09.278.809.809,0,0,0,.188.631.8.8,0,0,0,.471.27l9.228,1.732A9.5,9.5,0,1,1,18.2,47.9Zm16.6,3.991A2.02,2.02,0,1,1,30.041,60.5a2.036,2.036,0,0,1-2.009-2.039"
                            transform="translate(0 -12.18)"
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth="0.05"
                          />
                          <path
                            id="Path_2183"
                            dataname="Path 2183"
                            d="M17.911,56.461a8.26,8.26,0,1,0-3.625,15.712,8.149,8.149,0,0,0,7.283-4.462.808.808,0,1,0-1.439-.738,6.542,6.542,0,0,1-5.844,3.581,6.657,6.657,0,1,1,2.919-12.638.809.809,0,1,0,.705-1.456"
                            transform="translate(-2.3 -21.022)"
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth="0.05"
                          />
                          <path
                            id="Path_2184"
                            dataname="Path 2184"
                            d="M49.44,84.235H38.264a.809.809,0,0,0,0,1.618H49.44a.809.809,0,1,0,0-1.618"
                            transform="translate(-14.155 -31.835)"
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth="0.05"
                          />
                          <path
                            id="Path_2185"
                            dataname="Path 2185"
                            d="M32.674,23.02h0a.809.809,0,0,0,.6-.265c3.3-3.639,6.852-9.959,6.852-15.237a7.452,7.452,0,1,0-14.9,0c0,5.247,3.551,11.574,6.851,15.233a.806.806,0,0,0,.6.268m-5.833-15.5a5.835,5.835,0,1,1,11.668,0c0,4.511-2.891,9.946-5.832,13.46-2.944-3.532-5.836-8.973-5.836-13.46"
                            transform="translate(-9.532 0)"
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth="0.05"
                          />
                          <path
                            id="Path_2186"
                            dataname="Path 2186"
                            d="M39.148,9.067a4.919,4.919,0,1,0-4.928,4.95,4.955,4.955,0,0,0,4.928-4.95m-1.617,0a3.3,3.3,0,1,1-3.311-3.352A3.325,3.325,0,0,1,37.53,9.067"
                            transform="translate(-11.077 -1.549)"
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth="0.05"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                  <h4 className="CoreIconLabels">24/7 cycle rescue</h4>
                  <p className="font-16 coreIconText">
                    Cycle rescue from anywhere within the UK as long as you’re
                    further than a mile away from your home address.
                  </p>
                </article>
              </div>
            </div>

            <div className="row">
              {/* second row of icons...  */}
              <div className="col-6 col-md-12 col-xl-6">
                <article className="bikeBucket text-left mb-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="135"
                    height="135"
                    viewBox="0 0 135 135"
                    className="CoreIcon"
                  >
                    <defs>
                      <filter
                        id="Rectangle_748"
                        x="0"
                        y="0"
                        width="135"
                        height="135"
                        filterUnits="userSpaceOnUse"
                      >
                        <feOffset dy="2" input="SourceAlpha" />
                        <feGaussianBlur stdDeviation="1.5" result="blur" />
                        <feFlood floodOpacity="0.2" />
                        <feComposite operator="in" in2="blur" />
                        <feComposite in="SourceGraphic" />
                      </filter>
                      <clipPath id="clipPath">
                        <rect
                          id="Rectangle_972"
                          data-name="Rectangle 972"
                          width="69.557"
                          height="77.12"
                          fill="#fff"
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Group_1808"
                      data-name="Group 1808"
                      transform="translate(-401.5 -727.5)"
                    >
                      <g
                        id="Group_1795"
                        data-name="Group 1795"
                        transform="translate(0 55)"
                      >
                        <g id="Group_1789" data-name="Group 1789">
                          <g
                            transform="matrix(1, 0, 0, 1, 401.5, 672.5)"
                            filter="url(#Rectangle_748)"
                          >
                            <rect
                              id="Rectangle_748-2"
                              data-name="Rectangle 748"
                              width="126"
                              height="126"
                              rx="32"
                              transform="translate(4.5 2.5)"
                              fill="#00a8ff"
                            />
                          </g>
                        </g>
                        <g
                          id="Group_2186"
                          data-name="Group 2186"
                          transform="translate(434.222 699.44) scale(1.4)"
                        >
                          <path
                            id="Path_2147"
                            dataname="Path 2147"
                            d="M33.963,35.712a16.571,16.571,0,0,1,.943,4.439l.008.217H31.269l-.059-1.321c-.034-.383-.087-.758-.137-1.135a9.171,9.171,0,0,1-1.671.622c.047.418.088.839.113,1.266l.018.568h-6.2l-.056-2.313a9.235,9.235,0,0,1-1.807-1.069c.017.286.038.575.05.858l.062,2.524H15.112l.062-2.52c.051-1.08.131-2.168.237-3.23l.125-1.079.412.04c.817.051,1.743.069,2.751.042a9.15,9.15,0,0,1-.633-1.734l-.215,0c-.585,0-1.175-.019-1.8-.057l-.278-.025.015-.108c.141-.913.307-1.762.493-2.524a14.211,14.211,0,0,1,1.224-3.522c.377-.677.656-.854.734-.89l.116-.031.074.015a1.353,1.353,0,0,1,.459.433A9.3,9.3,0,0,1,20.429,23.1a18.352,18.352,0,0,0-2.084-.122L17.406,23a18.278,18.278,0,0,0-12.34,5.677l-.136.154-.132.057-.04.024a.948.948,0,0,0-.248.278l-.08.217-.478.552A18.141,18.141,0,0,0,0,41.325,18.332,18.332,0,0,0,17.411,59.65l.933.024h0A18.338,18.338,0,0,0,35.168,34a9.278,9.278,0,0,1-1.205,1.707m-10.941,12.5c.105-1.057.188-2.177.246-3.334l.065-2.774h6.2l-.022.75a22.014,22.014,0,0,1-1.487,6.858l-.306.7-.756-.289a24.9,24.9,0,0,0-3.411-.9l-.637-.1Zm-1.436-6.108-.069,2.7c-.049,1.068-.128,2.154-.234,3.227l-.1.844-1.367-.127c-.61-.043-1.255-.064-1.97-.064-.624,0-1.263.018-1.91.052l-.444.046-.085-.75c-.106-1.058-.186-2.145-.238-3.225l-.066-2.705Zm-5.809-16.93a17.281,17.281,0,0,0-1.2,3.593c-.183.752-.354,1.619-.523,2.653l-.027.206-1.395-.216a23.35,23.35,0,0,1-2.894-.723l.028-.055a11.744,11.744,0,0,1,6.008-5.458m-2.1,9.261c-.11,1.064-.191,2.185-.243,3.335l-.062,2.593H7.162l.018-.569a22.039,22.039,0,0,1,1.49-6.864l.289-.66L9,32.288a25.193,25.193,0,0,0,3.326.847l1.474.225Zm.086,14.528-1.445.222a25.621,25.621,0,0,0-3.328.845l-.146.055-.169-.38a22.214,22.214,0,0,1-1.495-6.852l-.024-.749h6.21l.068,2.778c.051,1.135.132,2.256.243,3.333ZM6.9,29.315a16.494,16.494,0,0,1,3.531-2.579l.045-.022a16.158,16.158,0,0,0-1.823,2.4l-.544.986c-.436-.182-.849-.373-1.223-.566l-.126-.071ZM1.792,40.156a16.43,16.43,0,0,1,3.617-9.222l.136-.151.536.306c.451.224.849.408,1.261.582l-.448,1.036a24.315,24.315,0,0,0-1.41,6.345l-.056,1.316-3.638,0H1.783ZM5.35,51.65a16.466,16.466,0,0,1-3.558-9.144l-.016-.4,3.642.008.066,1.5a24.148,24.148,0,0,0,1.422,6.337l.332.764-1.165.535Zm5.09,4.274A16.511,16.511,0,0,1,6.908,53.35l-.348-.378.315-.178,1.1-.5.7,1.247a15.968,15.968,0,0,0,1.845,2.427Zm-.658-3.916-.174-.334a24.477,24.477,0,0,1,3.022-.767l1.352-.208.075.538c.167,1.02.338,1.887.522,2.647a17.432,17.432,0,0,0,1.2,3.588,11.83,11.83,0,0,1-6-5.464M20.42,53.481A14.461,14.461,0,0,1,19.193,57a2.1,2.1,0,0,1-.734.9l-.112.029-.082-.019c-.1-.046-.383-.225-.761-.907a13.938,13.938,0,0,1-1.223-3.516c-.185-.768-.351-1.617-.493-2.522l-.063-.438.322-.029c.574-.038,1.181-.057,1.8-.057.666,0,1.275.02,1.86.06l1.249.115-.053.347c-.137.881-.3,1.731-.486,2.524m.493,4a17.449,17.449,0,0,0,1.206-3.6c.187-.8.362-1.69.52-2.652l.05-.38.549.088a23.308,23.308,0,0,1,3.15.831l.553.213-.014.03a11.733,11.733,0,0,1-6.013,5.466m5.356-1.559-.057.027a16.057,16.057,0,0,0,1.828-2.4l.49-.881.568.271.7.416a16.634,16.634,0,0,1-3.523,2.572M34.906,42.5a16.488,16.488,0,0,1-3.615,9.222L31,52.038,29.928,51.4l-.622-.3L29.8,49.95a24.217,24.217,0,0,0,1.41-6.345l.068-1.5H34.92Z"
                            transform="translate(0 -12.034)"
                            fill="#fff"
                          />
                          <path
                            id="Path_2148"
                            dataname="Path 2148"
                            d="M72.022,10.038a7.133,7.133,0,0,0-2.8.57l-.055.026L68.29,6.321l1.14-.314a.847.847,0,0,0,.546-.459l.844-1.767a.861.861,0,0,0-.355-1.12L65.9.107a.86.86,0,0,0-.658-.072.84.84,0,0,0-.506.406.857.857,0,0,0,.33,1.168l2.542,1.423-2.34-.785a.856.856,0,0,0-.658.047.845.845,0,0,0-.428.49.864.864,0,0,0,.536,1.09l2.7.908-.354.1a.858.858,0,0,0-.614,1l.221,1.079L57.244,8.986,56.627,6.8l.026,0A6.51,6.51,0,0,0,58.2,6.607a.859.859,0,0,0-.416-1.667,4.437,4.437,0,0,1-2.467-.069,8.325,8.325,0,0,1-2.347-1.234.839.839,0,0,0-.639-.145.857.857,0,0,0-.352,1.544A9.928,9.928,0,0,0,54.761,6.5l.545,1.939-1.912,2.515-.066-.041a7.187,7.187,0,1,0,3.437,8.446l.042-.162,1.393.191L60.6,21.9l-.4.452a.862.862,0,0,0,.616,1.428.86.86,0,0,0,.671-.289l1.873-2.121a.859.859,0,1,0-1.287-1.137l-.334.378-1.618-1.7L67.5,11.039l.089.43a.748.748,0,0,0,.033.121l-.678.557a7.181,7.181,0,1,0,5.078-2.109m-3.431-6.41c-.012-.023-.024-.046-.037-.068l.374.21-.329.686-.056.015a.9.9,0,0,0,.091-.187.852.852,0,0,0-.043-.656M54.942,19.353a5.469,5.469,0,1,1-5.041-7.6,5.363,5.363,0,0,1,2.113.427l.317.172-3.393,4.473A.859.859,0,0,0,49.5,18.2l5.562.755Zm.424-2.087-4.174-.57,2.548-3.361.028.023a5.438,5.438,0,0,1,1.6,3.848Zm1.8-1.463a.84.84,0,0,0-.267-.181l-.137-.535a7.242,7.242,0,0,0-1.8-2.952l-.194-.16L55.891,10.5l1.583,5.622Zm2.346,1.237-1.8-6.4,9.3-2,.07.343Zm12.509,5.653a5.471,5.471,0,0,1-3.88-9.322l.3-.244.373.686-.293.234a5.29,5.29,0,0,0-1.183,1.708.856.856,0,0,0,.441,1.131.979.979,0,0,0,.329.075.868.868,0,0,0,.8-.515,3.581,3.581,0,0,1,.74-1.1l1.5,2.77a.867.867,0,0,0,.72.449.8.8,0,0,0,.118-.006.879.879,0,0,0,.322-.1.858.858,0,0,0,.348-1.162L71.084,14.41a.869.869,0,0,0,.3-1.038.858.858,0,0,0-.475-.461.843.843,0,0,0-.633,0l-.389-.72.009,0a5.4,5.4,0,0,1,2.128-.434,5.469,5.469,0,1,1,0,10.937"
                            transform="translate(-22.369 0)"
                            fill="#fff"
                          />
                          <path
                            id="Path_2149"
                            dataname="Path 2149"
                            d="M52.052,27.818a.848.848,0,0,0-.006-.662.839.839,0,0,0-.457-.459.857.857,0,0,0-.662,0A5.367,5.367,0,0,0,48,29.534a.867.867,0,0,0,.767,1.205h.024a.845.845,0,0,0,.781-.515,3.666,3.666,0,0,1,2.019-1.946.836.836,0,0,0,.461-.462"
                            transform="translate(-25.096 -13.945)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                  <h4 className="CoreIconLabels">European cover</h4>
                  <p className="font-16 coreIconText coreiconSecondRow">
                    You will be covered to use your bicycle in Europe for up to
                    90 days in one period. (territorial limits apply)
                  </p>
                </article>
              </div>
              <div className="col-6 col-md-12 col-xl-6">
                <article className="bikeBucket text-left mb-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="135"
                    height="135"
                    viewBox="0 0 135 135"
                    className="CoreIcon"
                  >
                    <defs>
                      <filter
                        id="Rectangle_748"
                        x="0"
                        y="0"
                        width="135"
                        height="135"
                        filterUnits="userSpaceOnUse"
                      >
                        <feOffset dy="2" input="SourceAlpha" />
                        <feGaussianBlur stdDeviation="1.5" result="blur" />
                        <feFlood floodOpacity="0.2" />
                        <feComposite operator="in" in2="blur" />
                        <feComposite in="SourceGraphic" />
                      </filter>
                      <clipPath id="clipPath12345">
                        <rect
                          id="Rectangle_972"
                          data-name="Rectangle 972"
                          width="69.557"
                          height="77.12"
                          fill="#fff"
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Group_1808"
                      data-name="Group 1808"
                      transform="translate(-401.5 -727.5)"
                    >
                      <g
                        id="Group_1795"
                        data-name="Group 1795"
                        transform="translate(0 55)"
                      >
                        <g id="Group_1789" data-name="Group 1789">
                          <g
                            transform="matrix(1, 0, 0, 1, 401.5, 672.5)"
                            filter="url(#Rectangle_748)"
                          >
                            <rect
                              id="Rectangle_748-2"
                              data-name="Rectangle 748"
                              width="126"
                              height="126"
                              rx="32"
                              transform="translate(4.5 2.5)"
                              fill="#00a8ff"
                            />
                          </g>
                        </g>
                        <g
                          id="Group_2186"
                          data-name="Group 2186"
                          transform="translate(434.222 699.44)"
                        >
                          <g
                            id="Group_2141"
                            data-name="Group 2141"
                            clipPath="url(#clipPath12345)"
                            scale="2.2"
                          >
                            <path
                              id="Path_2157"
                              data-name="Path 2157"
                              d="M68.6,24.477a4.853,4.853,0,0,0-2.505-1.755l-15.878-4.8a4.822,4.822,0,0,0-3.715.4,4.773,4.773,0,0,0-1.764,1.7L37.8,31.51a66.375,66.375,0,0,1-8.9-3.976,4.033,4.033,0,0,0,.338-.309,14.063,14.063,0,0,0,3.923-9.707,13.816,13.816,0,0,0-.15-2.021L31.246,3.671a4.265,4.265,0,0,0-.5-1.462A4.355,4.355,0,0,0,29.21.612,4.187,4.187,0,0,0,24.921.569,4.239,4.239,0,0,0,22.81,4.23a4.161,4.161,0,0,0,.047.628l1.771,11.887a5.437,5.437,0,0,1,.058.785,5.52,5.52,0,0,1-1.31,3.549L18.569,24.55a7.96,7.96,0,0,0-2.7,1.2c-.123.084-.234.182-.352.272a8.18,8.18,0,0,0,.968-3.861,8.236,8.236,0,0,0-3.452-6.711l0-.007-.306-.2-.005,0-.3-.195,0,.007a8.192,8.192,0,0,0-4.166-1.138h0a8.233,8.233,0,0,0-6.916,3.753A8.2,8.2,0,0,0,0,22.146a8.236,8.236,0,0,0,3.754,6.917,8.2,8.2,0,0,0,4.476,1.33h0a8.3,8.3,0,0,0,3.876-.965,8.108,8.108,0,0,0,1.232-.824l-.483.85a8.351,8.351,0,0,0-1.09,4.2,10,10,0,0,0,.336,2.541l.26,10.443a14.02,14.02,0,0,0,4.414,9.9,1.495,1.495,0,1,0,2.043-2.182,10.985,10.985,0,0,1-3.469-7.789L15.09,35.944a1.532,1.532,0,0,0-.057-.367,7.054,7.054,0,0,1-.275-1.923,5.824,5.824,0,0,1,.175-1.439,4.962,4.962,0,0,1,.524-1.285L16.1,29.8a4.927,4.927,0,0,1,3.382-2.393,1.491,1.491,0,0,0,.588-.255l5.2-3.753a1.461,1.461,0,0,0,.231-.208,8.432,8.432,0,0,0,2.175-5.661,8.247,8.247,0,0,0-.091-1.225L25.812,4.416a1.24,1.24,0,0,1,.279-.985,1.263,1.263,0,0,1,.329-.277A1.232,1.232,0,0,1,26.839,3a1.126,1.126,0,0,1,.619.064,1.341,1.341,0,0,1,.833,1.043l1.761,11.825a10.957,10.957,0,0,1-2.963,9.206,1.083,1.083,0,0,1-.149.126l-1.684,1.217a1.495,1.495,0,0,0,.12,2.5,69.252,69.252,0,0,0,11.5,5.369,8.466,8.466,0,0,1,.868.372,1.5,1.5,0,0,0,1.942-.566l7.607-12.586a1.778,1.778,0,0,1,.661-.639,1.812,1.812,0,0,1,1.4-.151l15.878,4.8a1.893,1.893,0,0,1,.975.683,1.818,1.818,0,0,1,.365,1.073,1.7,1.7,0,0,1-.061.452,1.788,1.788,0,0,1-.652.965,1.812,1.812,0,0,1-1.079.362,1.766,1.766,0,0,1-.521-.077l-13.5-4.079a1.488,1.488,0,0,0-1.71.657L41.684,37.8a1.5,1.5,0,0,0-.154,1.194,5.457,5.457,0,0,1,.223,1.539c0,.082,0,.164-.005.244a1.5,1.5,0,0,0,1.413,1.56l11.16.589a1.795,1.795,0,0,1,1.666,1.441L59.253,60.7a1.863,1.863,0,0,1,.036.355,1.805,1.805,0,0,1-.4,1.13,1.791,1.791,0,0,1-1.041.628,1.815,1.815,0,0,1-.356.036h0A1.8,1.8,0,0,1,55.73,61.4L52.966,47.576a1.494,1.494,0,0,0-1.387-1.2l-8.832-.467a12.4,12.4,0,0,0-4.967.776,7.714,7.714,0,0,1-5.052.007,76.256,76.256,0,0,1-12.764-5.608,1.495,1.495,0,0,0-2.218,1.344l.1,4.081.365-.007v.009l-.365.005h.176l-.176,0a8.449,8.449,0,0,0,3.4,6.615L30.91,60.29a1.248,1.248,0,0,1,.377.449,1.271,1.271,0,0,1,.129.556,1.247,1.247,0,0,1-.245.74,1.259,1.259,0,0,1-.449.376,1.243,1.243,0,0,1-1.3-.116,1.527,1.527,0,0,0-.286-.166l-2.268-1a1.494,1.494,0,1,0-1.206,2.734l2.12.929a4.228,4.228,0,0,0,1.076.532,4.235,4.235,0,0,0,4.712-1.509,4.221,4.221,0,0,0,.832-2.519,4.233,4.233,0,0,0-1.715-3.407l-9.657-7.153a5.455,5.455,0,0,1-2.2-4.3L20.8,44.915a79.286,79.286,0,0,0,10.986,4.614,10.707,10.707,0,0,0,7.021-.034,9.5,9.5,0,0,1,3.783-.6l7.676.405L52.8,61.989a4.785,4.785,0,0,0,9.478-.935,4.829,4.829,0,0,0-.093-.941L58.917,43.78a4.788,4.788,0,0,0-4.439-3.84l-9.812-.518c-.027-.2-.061-.406-.1-.608L51,28.158,63.391,31.9a4.846,4.846,0,0,0,4.259-.756,4.793,4.793,0,0,0,1.741-2.568,4.715,4.715,0,0,0,.166-1.237,4.826,4.826,0,0,0-.96-2.863m-55.1-2.319a5.255,5.255,0,0,1-2.784,4.63,5.337,5.337,0,0,1-5.328-.232A5.193,5.193,0,0,1,3.605,24.62a5.248,5.248,0,0,1,.231-5.328,5.19,5.19,0,0,1,1.937-1.777A5.286,5.286,0,0,1,8.245,16.9h0a5.256,5.256,0,0,1,4.63,2.783,5.306,5.306,0,0,1,.616,2.475"
                              transform="translate(0 0)"
                              fill="#fff"
                            />
                            <path
                              id="Path_2158"
                              data-name="Path 2158"
                              d="M55.635,80.154l8.986,3.691a1.494,1.494,0,1,0,1.136-2.764L56.77,77.389a1.494,1.494,0,0,0-1.136,2.765"
                              transform="translate(-14.758 -20.846)"
                              fill="#fff"
                            />
                            <path
                              id="Path_2159"
                              data-name="Path 2159"
                              d="M62.251,92.606a1.5,1.5,0,0,0-1.495-1.494h-20a1.494,1.494,0,1,0,0,2.988h20a1.5,1.5,0,0,0,1.495-1.494"
                              transform="translate(-10.592 -24.579)"
                              fill="#fff"
                            />
                            <path
                              id="Path_2160"
                              data-name="Path 2160"
                              d="M74.222,93.981a1.5,1.5,0,0,0-2.051.51l-3.407,5.659a1.495,1.495,0,0,0,2.561,1.542l3.407-5.659a1.494,1.494,0,0,0-.51-2.051"
                              transform="translate(-18.492 -25.295)"
                              fill="#fff"
                            />
                            <path
                              id="Path_2161"
                              data-name="Path 2161"
                              d="M29.285,79.795a1.5,1.5,0,1,0,1.5,1.5,1.5,1.5,0,0,0-1.5-1.5"
                              transform="translate(-7.495 -21.526)"
                              fill="#fff"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <h4 className="CoreIconLabels">Personal accident</h4>
                  <p className="font-16 coreIconText coreiconSecondRow">
                    Should the worst happen and suffer a bodily injury from use
                    of your bicycle, up to £25,000 will be paid.
                  </p>
                </article>
              </div>

              <p className="font-14 mb-5 coreExtraPadding">
                <span className="infoIconBlue ">{infoIcon} </span> All elements
                of our Performance policy can be{" "}
                <HashLink
                  scroll={(el) =>
                    el.scrollIntoView({ behavior: "smooth", block: "start" })
                  }
                  to="/OurCoverLevels#CorePerformanceComparisonTable"
                >
                  <span className="blueFont">found here</span>
                </HashLink>
                .
              </p>
              <CTAButton
                align="left"
                colour="green"
                CTAText="Get a quote"
                onClick={() => {
                  sessionStorage.removeItem("context");
                }}
                Url={`/get-a-quote${search}`}
              />
            </div>
          </div>

          {/* hide this version for MD and above */}
          <div className="col-12 d-block d-md-none">
            <div className="row">
              <div className="col-2">
                <article className="bikeBucket mb-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="135"
                    height="135"
                    viewBox="0 0 135 135"
                    className="CoreIcon"
                  >
                    <defs>
                      <filter
                        id="Rectangle_748"
                        x="0"
                        y="0"
                        width="135"
                        height="135"
                        filterUnits="userSpaceOnUse"
                      >
                        <feOffset dy="2" input="SourceAlpha" />
                        <feGaussianBlur stdDeviation="1.5" result="blur" />
                        <feFlood floodOpacity="0.2" />
                        <feComposite operator="in" in2="blur" />
                        <feComposite in="SourceGraphic" />
                      </filter>
                      <clipPath id="clipPath">
                        <rect
                          id="Rectangle_972"
                          data-name="Rectangle 972"
                          width="69.557"
                          height="77.12"
                          fill="#fff"
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Group_1808"
                      data-name="Group 1808"
                      transform="translate(-401.5 -727.5)"
                    >
                      <g
                        id="Group_1795"
                        data-name="Group 1795"
                        transform="translate(0 55)"
                      >
                        <g id="Group_1789" data-name="Group 1789">
                          <g
                            transform="matrix(1, 0, 0, 1, 401.5, 672.5)"
                            filter="url(#Rectangle_748)"
                          >
                            <rect
                              id="Rectangle_748-2"
                              data-name="Rectangle 748"
                              width="126"
                              height="126"
                              rx="32"
                              transform="translate(4.5 2.5)"
                              fill="#00a8ff"
                            />
                          </g>
                        </g>
                        <g
                          id="Group_2186"
                          data-name="Group 2186"
                          transform="translate(429.222 699.44) scale(1.6)"
                        >
                          <path
                            id="Path_2085"
                            dataname="Path 20885"
                            d="M48.841,32.139H34.091V20.04a1.148,1.148,0,0,0-1.148-1.148H31.1V15.817a.8.8,0,0,0-.8-.8H27.564V11.4a.78.78,0,0,0-.009-.087A4.552,4.552,0,0,0,28.99,9.406a.784.784,0,0,0,.094-.073c4.269-4.091,4.789-4.571,4.847-4.624.015-.012.029-.026.043-.04A2.213,2.213,0,0,0,32.42.883H30.208A.8.8,0,0,0,29.41,0H20.578a.8.8,0,0,0-.8.883H17.568a2.214,2.214,0,0,0-1.554,3.786c.014.014.028.028.043.04.058.052.577.532,4.848,4.624a.809.809,0,0,0,.089.07,4.55,4.55,0,0,0,1.438,1.914.758.758,0,0,0-.009.085v3.612H19.7a.8.8,0,0,0-.8.8v3.074H17.046A1.148,1.148,0,0,0,15.9,20.04v6.8H1.148A1.148,1.148,0,0,0,0,27.988v21.2a1.148,1.148,0,0,0,1.148,1.148H48.841a1.148,1.148,0,0,0,1.148-1.148v-15.9a1.148,1.148,0,0,0-1.148-1.148M33.023,3.094a.609.609,0,0,1-.181.435l.006.006c-.323.28-1.117,1.035-3.365,3.188l.527-4.232h2.41a.6.6,0,0,1,.6.6m-16.056,0a.6.6,0,0,1,.6-.6h2.409L20.5,6.72c-2.246-2.151-3.039-2.906-3.362-3.185l.007-.006a.609.609,0,0,1-.181-.435m4.522-1.486H28.5l-.8,6.438a2.9,2.9,0,0,1-1.9,2.422,2.581,2.581,0,0,1-1.617,0,2.9,2.9,0,0,1-1.9-2.422Zm2.544,10.485a4.132,4.132,0,0,0,1.925,0v2.922H24.032ZM20.5,16.621H29.49v2.27H20.5ZM2.3,29.137H15.9v18.9H2.3Zm15.9-7.949h13.6V48.036h-13.6Zm29.5,26.848h-13.6v-13.6h13.6Z"
                            transform="translate(0 0)"
                            fill="#fff"
                          />
                          <path
                            id="Path_2086"
                            dataname="Path 2086"
                            d="M53.163,61.136a1.226,1.226,0,0,0-.687-.2.775.775,0,0,0-.419.1l-1.909,1.157a.825.825,0,0,0-.419.767,1.022,1.022,0,0,0,.2.621.607.607,0,0,0,.505.274.639.639,0,0,0,.362-.116l.419-.26v7.36a.558.558,0,0,0,.333.513,1.836,1.836,0,0,0,1.59,0,.56.56,0,0,0,.333-.513v-9.2a.594.594,0,0,0-.311-.506"
                            transform="translate(-26.888 -32.945)"
                            fill="#fff"
                          />
                          <path
                            id="Path_2087"
                            dataname="Path 2087"
                            d="M18.516,81.1H14.692v-.132a1.126,1.126,0,0,1,.47-.77,10.291,10.291,0,0,1,1.132-.858q.664-.44,1.319-.967a4.867,4.867,0,0,0,1.122-1.3,3.167,3.167,0,0,0,.466-1.656,2.575,2.575,0,0,0-1.02-2.144,3.747,3.747,0,0,0-2.372-.8,3.612,3.612,0,0,0-2.289.761,2.438,2.438,0,0,0-.973,2.023q0,1.174,1,1.174a1.325,1.325,0,0,0,.852-.255.751.751,0,0,0,.322-.6,1.085,1.085,0,0,1,.309-.858,1.156,1.156,0,0,1,.793-.271,1.022,1.022,0,0,1,1.117,1.04,1.626,1.626,0,0,1-.478,1.056,6.967,6.967,0,0,1-1.169,1.041l-1.331,1A5.568,5.568,0,0,0,12.838,79.7a2.1,2.1,0,0,0-.465,1.255v1.416a.588.588,0,0,0,.325.5,1.241,1.241,0,0,0,.661.2H18.52a.577.577,0,0,0,.478-.3,1.227,1.227,0,0,0,.2-.7,1.15,1.15,0,0,0-.2-.681.585.585,0,0,0-.481-.29"
                            transform="translate(-6.69 -39.182)"
                            fill="#fff"
                          />
                          <path
                            id="Path_2088"
                            dataname="Path 2088"
                            d="M83.579,81.716a1.266,1.266,0,0,0,.825-.2.763.763,0,0,0,.23-.6.607.607,0,0,1,.257-.557,1.53,1.53,0,0,1,.8-.162.919.919,0,0,1,1.057,1.022,2.045,2.045,0,0,1-.093.673.656.656,0,0,1-.272.369,1.135,1.135,0,0,1-.341.142,1.989,1.989,0,0,1-.407.035c-.427,0-.642.288-.642.863s.214.863.641.863a1.816,1.816,0,0,1,1.022.237,1.026,1.026,0,0,1,.351.912v.274a1.389,1.389,0,0,1-.294,1,1.42,1.42,0,0,1-1.023.295q-1.273,0-1.272-.833a.659.659,0,0,0-.24-.583,1.751,1.751,0,0,0-.92-.166,1.47,1.47,0,0,0-.838.173.764.764,0,0,0-.232.647A2.557,2.557,0,0,0,83.054,88a3.557,3.557,0,0,0,2.566.835,4.11,4.11,0,0,0,2.633-.792,2.945,2.945,0,0,0,1-2.458v-.274A2.075,2.075,0,0,0,87.79,83.2a1.717,1.717,0,0,0,.819-.884,3.411,3.411,0,0,0,.3-1.454q0-2.622-3.214-2.623a3.436,3.436,0,0,0-2.486.783,2.445,2.445,0,0,0-.8,1.79.945.945,0,0,0,.21.726,1.659,1.659,0,0,0,.963.18"
                            transform="translate(-44.438 -42.3)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </article>
              </div>
              <div className="col-4">
                <p className="lufga-medium font-15 mt-5 prExtraSmall">
                  Sports & events
                </p>
              </div>

              <div className="col-2">
                <article className="bikeBucket mb-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="135"
                    height="135"
                    viewBox="0 0 135 135"
                    className="CoreIcon"
                  >
                    <defs>
                      <filter
                        id="Rectangle_748"
                        x="0"
                        y="0"
                        width="135"
                        height="135"
                        filterUnits="userSpaceOnUse"
                      >
                        <feOffset dy="2" input="SourceAlpha" />
                        <feGaussianBlur stdDeviation="1.5" result="blur" />
                        <feFlood floodOpacity="0.2" />
                        <feComposite operator="in" in2="blur" />
                        <feComposite in="SourceGraphic" />
                      </filter>
                      <clipPath id="clipPath">
                        <rect
                          id="Rectangle_972"
                          data-name="Rectangle 972"
                          width="69.557"
                          height="77.12"
                          fill="#fff"
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Group_1808"
                      data-name="Group 1808"
                      transform="translate(-401.5 -727.5)"
                    >
                      <g
                        id="Group_1795"
                        data-name="Group 1795"
                        transform="translate(0 55)"
                      >
                        <g id="Group_1789" data-name="Group 1789">
                          <g
                            transform="matrix(1, 0, 0, 1, 401.5, 672.5)"
                            filter="url(#Rectangle_748)"
                          >
                            <rect
                              id="Rectangle_748-2"
                              data-name="Rectangle 748"
                              width="126"
                              height="126"
                              rx="32"
                              transform="translate(4.5 2.5)"
                              fill="#00a8ff"
                            />
                          </g>
                        </g>
                        <g
                          id="Group_2186"
                          data-name="Group 2186"
                          transform="translate(424.222 699.44) scale(1.4)"
                        >
                          <path
                            id="Path_2181"
                            dataname="Path 2181"
                            d="M63.851,63.9a6.715,6.715,0,0,1,2.3-5.064.808.808,0,0,0-.477-1.416.78.78,0,0,0-.585.2A8.331,8.331,0,0,0,62.233,63.9a8.2,8.2,0,1,0,8.2-8.275.809.809,0,0,0,0,1.618A6.657,6.657,0,1,1,63.851,63.9"
                            transform="translate(-23.519 -21.022)"
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth="0.05"
                          />
                          <path
                            id="Path_2182"
                            dataname="Path 2182"
                            d="M58.111,64.58H52.639a11.159,11.159,0,0,0-5.725-20.665,10.914,10.914,0,0,0-2.88.385L41.59,37.263a.673.673,0,0,0-.038-.114l-1.514-4.362a.848.848,0,0,0-.065-.145.78.78,0,0,0-.24-.267.809.809,0,0,0-.321-.134.774.774,0,0,0-.156-.013h-5.9a2.143,2.143,0,0,0,0,4.285.809.809,0,0,0,0-1.617.525.525,0,0,1,0-1.051h5.339l1.1,3.169L21.648,44.908l-2.731-3.916h2.176a.321.321,0,0,1,.315.327.809.809,0,0,0,1.617,0,1.941,1.941,0,0,0-1.932-1.944H15a1.919,1.919,0,0,0-1.933,1.944A1.941,1.941,0,0,0,15,43.262a.809.809,0,0,0,0-1.617.321.321,0,0,1-.315-.326A.307.307,0,0,1,15,40.992h1.943l3.38,4.847-.964.935a10.924,10.924,0,0,0-7.377-2.86A11.159,11.159,0,0,0,6.263,64.58H.809a.809.809,0,0,0,0,1.618H11.986a11.014,11.014,0,0,0,10.68-8.315l3.75.7a3.664,3.664,0,1,0,.3-1.59l-3.756-.7a11.4,11.4,0,0,0,.068-1.236,11.186,11.186,0,0,0-2.547-7.112l.785-.761,4.981,7.141A.808.808,0,1,0,27.57,53.4l-4.977-7.138,17.732-7.714.435,1.257L32.076,53.691a.809.809,0,1,0,1.372.858l7.995-12.784,1.067,3.074a11.159,11.159,0,0,0,4.4,21.358h11.2a.809.809,0,0,0,0-1.618M47.179,55.82a.809.809,0,0,0,.5-1.03l-3.112-8.959a9.3,9.3,0,0,1,2.347-.3,9.447,9.447,0,1,1-3.871.841l3.107,8.949a.807.807,0,0,0,1.029.5M19.313,49.075a9.581,9.581,0,0,1,2.1,5.981c0,.31-.016.625-.046.937L13.67,54.549Zm-7.882,5.394a.79.79,0,0,0-.156.2.776.776,0,0,0-.09.278.809.809,0,0,0,.188.631.8.8,0,0,0,.471.27l9.228,1.732A9.5,9.5,0,1,1,18.2,47.9Zm16.6,3.991A2.02,2.02,0,1,1,30.041,60.5a2.036,2.036,0,0,1-2.009-2.039"
                            transform="translate(0 -12.18)"
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth="0.05"
                          />
                          <path
                            id="Path_2183"
                            dataname="Path 2183"
                            d="M17.911,56.461a8.26,8.26,0,1,0-3.625,15.712,8.149,8.149,0,0,0,7.283-4.462.808.808,0,1,0-1.439-.738,6.542,6.542,0,0,1-5.844,3.581,6.657,6.657,0,1,1,2.919-12.638.809.809,0,1,0,.705-1.456"
                            transform="translate(-2.3 -21.022)"
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth="0.05"
                          />
                          <path
                            id="Path_2184"
                            dataname="Path 2184"
                            d="M49.44,84.235H38.264a.809.809,0,0,0,0,1.618H49.44a.809.809,0,1,0,0-1.618"
                            transform="translate(-14.155 -31.835)"
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth="0.05"
                          />
                          <path
                            id="Path_2185"
                            dataname="Path 2185"
                            d="M32.674,23.02h0a.809.809,0,0,0,.6-.265c3.3-3.639,6.852-9.959,6.852-15.237a7.452,7.452,0,1,0-14.9,0c0,5.247,3.551,11.574,6.851,15.233a.806.806,0,0,0,.6.268m-5.833-15.5a5.835,5.835,0,1,1,11.668,0c0,4.511-2.891,9.946-5.832,13.46-2.944-3.532-5.836-8.973-5.836-13.46"
                            transform="translate(-9.532 0)"
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth="0.05"
                          />
                          <path
                            id="Path_2186"
                            dataname="Path 2186"
                            d="M39.148,9.067a4.919,4.919,0,1,0-4.928,4.95,4.955,4.955,0,0,0,4.928-4.95m-1.617,0a3.3,3.3,0,1,1-3.311-3.352A3.325,3.325,0,0,1,37.53,9.067"
                            transform="translate(-11.077 -1.549)"
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth="0.05"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </article>
              </div>

              <div className="col-4">
                <p className="lufga-medium font-15 mt-5 prExtraSmall">
                  24/7 cycle rescue
                </p>
              </div>

              <div className="col-2">
                <article className="bikeBucket mb-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="135"
                    height="135"
                    viewBox="0 0 135 135"
                    className="CoreIcon"
                  >
                    <defs>
                      <filter
                        id="Rectangle_748"
                        x="0"
                        y="0"
                        width="135"
                        height="135"
                        filterUnits="userSpaceOnUse"
                      >
                        <feOffset dy="2" input="SourceAlpha" />
                        <feGaussianBlur stdDeviation="1.5" result="blur" />
                        <feFlood floodOpacity="0.2" />
                        <feComposite operator="in" in2="blur" />
                        <feComposite in="SourceGraphic" />
                      </filter>
                      <clipPath id="clipPath">
                        <rect
                          id="Rectangle_972"
                          data-name="Rectangle 972"
                          width="69.557"
                          height="77.12"
                          fill="#fff"
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Group_1808"
                      data-name="Group 1808"
                      transform="translate(-401.5 -727.5)"
                    >
                      <g
                        id="Group_1795"
                        data-name="Group 1795"
                        transform="translate(0 55)"
                      >
                        <g id="Group_1789" data-name="Group 1789">
                          <g
                            transform="matrix(1, 0, 0, 1, 401.5, 672.5)"
                            filter="url(#Rectangle_748)"
                          >
                            <rect
                              id="Rectangle_748-2"
                              data-name="Rectangle 748"
                              width="126"
                              height="126"
                              rx="32"
                              transform="translate(4.5 2.5)"
                              fill="#00a8ff"
                            />
                          </g>
                        </g>
                        <g
                          id="Group_2186"
                          data-name="Group 2186"
                          transform="translate(434.222 699.44) scale(1.4)"
                        >
                          <path
                            id="Path_2147"
                            dataname="Path 2147"
                            d="M33.963,35.712a16.571,16.571,0,0,1,.943,4.439l.008.217H31.269l-.059-1.321c-.034-.383-.087-.758-.137-1.135a9.171,9.171,0,0,1-1.671.622c.047.418.088.839.113,1.266l.018.568h-6.2l-.056-2.313a9.235,9.235,0,0,1-1.807-1.069c.017.286.038.575.05.858l.062,2.524H15.112l.062-2.52c.051-1.08.131-2.168.237-3.23l.125-1.079.412.04c.817.051,1.743.069,2.751.042a9.15,9.15,0,0,1-.633-1.734l-.215,0c-.585,0-1.175-.019-1.8-.057l-.278-.025.015-.108c.141-.913.307-1.762.493-2.524a14.211,14.211,0,0,1,1.224-3.522c.377-.677.656-.854.734-.89l.116-.031.074.015a1.353,1.353,0,0,1,.459.433A9.3,9.3,0,0,1,20.429,23.1a18.352,18.352,0,0,0-2.084-.122L17.406,23a18.278,18.278,0,0,0-12.34,5.677l-.136.154-.132.057-.04.024a.948.948,0,0,0-.248.278l-.08.217-.478.552A18.141,18.141,0,0,0,0,41.325,18.332,18.332,0,0,0,17.411,59.65l.933.024h0A18.338,18.338,0,0,0,35.168,34a9.278,9.278,0,0,1-1.205,1.707m-10.941,12.5c.105-1.057.188-2.177.246-3.334l.065-2.774h6.2l-.022.75a22.014,22.014,0,0,1-1.487,6.858l-.306.7-.756-.289a24.9,24.9,0,0,0-3.411-.9l-.637-.1Zm-1.436-6.108-.069,2.7c-.049,1.068-.128,2.154-.234,3.227l-.1.844-1.367-.127c-.61-.043-1.255-.064-1.97-.064-.624,0-1.263.018-1.91.052l-.444.046-.085-.75c-.106-1.058-.186-2.145-.238-3.225l-.066-2.705Zm-5.809-16.93a17.281,17.281,0,0,0-1.2,3.593c-.183.752-.354,1.619-.523,2.653l-.027.206-1.395-.216a23.35,23.35,0,0,1-2.894-.723l.028-.055a11.744,11.744,0,0,1,6.008-5.458m-2.1,9.261c-.11,1.064-.191,2.185-.243,3.335l-.062,2.593H7.162l.018-.569a22.039,22.039,0,0,1,1.49-6.864l.289-.66L9,32.288a25.193,25.193,0,0,0,3.326.847l1.474.225Zm.086,14.528-1.445.222a25.621,25.621,0,0,0-3.328.845l-.146.055-.169-.38a22.214,22.214,0,0,1-1.495-6.852l-.024-.749h6.21l.068,2.778c.051,1.135.132,2.256.243,3.333ZM6.9,29.315a16.494,16.494,0,0,1,3.531-2.579l.045-.022a16.158,16.158,0,0,0-1.823,2.4l-.544.986c-.436-.182-.849-.373-1.223-.566l-.126-.071ZM1.792,40.156a16.43,16.43,0,0,1,3.617-9.222l.136-.151.536.306c.451.224.849.408,1.261.582l-.448,1.036a24.315,24.315,0,0,0-1.41,6.345l-.056,1.316-3.638,0H1.783ZM5.35,51.65a16.466,16.466,0,0,1-3.558-9.144l-.016-.4,3.642.008.066,1.5a24.148,24.148,0,0,0,1.422,6.337l.332.764-1.165.535Zm5.09,4.274A16.511,16.511,0,0,1,6.908,53.35l-.348-.378.315-.178,1.1-.5.7,1.247a15.968,15.968,0,0,0,1.845,2.427Zm-.658-3.916-.174-.334a24.477,24.477,0,0,1,3.022-.767l1.352-.208.075.538c.167,1.02.338,1.887.522,2.647a17.432,17.432,0,0,0,1.2,3.588,11.83,11.83,0,0,1-6-5.464M20.42,53.481A14.461,14.461,0,0,1,19.193,57a2.1,2.1,0,0,1-.734.9l-.112.029-.082-.019c-.1-.046-.383-.225-.761-.907a13.938,13.938,0,0,1-1.223-3.516c-.185-.768-.351-1.617-.493-2.522l-.063-.438.322-.029c.574-.038,1.181-.057,1.8-.057.666,0,1.275.02,1.86.06l1.249.115-.053.347c-.137.881-.3,1.731-.486,2.524m.493,4a17.449,17.449,0,0,0,1.206-3.6c.187-.8.362-1.69.52-2.652l.05-.38.549.088a23.308,23.308,0,0,1,3.15.831l.553.213-.014.03a11.733,11.733,0,0,1-6.013,5.466m5.356-1.559-.057.027a16.057,16.057,0,0,0,1.828-2.4l.49-.881.568.271.7.416a16.634,16.634,0,0,1-3.523,2.572M34.906,42.5a16.488,16.488,0,0,1-3.615,9.222L31,52.038,29.928,51.4l-.622-.3L29.8,49.95a24.217,24.217,0,0,0,1.41-6.345l.068-1.5H34.92Z"
                            transform="translate(0 -12.034)"
                            fill="#fff"
                          />
                          <path
                            id="Path_2148"
                            dataname="Path 2148"
                            d="M72.022,10.038a7.133,7.133,0,0,0-2.8.57l-.055.026L68.29,6.321l1.14-.314a.847.847,0,0,0,.546-.459l.844-1.767a.861.861,0,0,0-.355-1.12L65.9.107a.86.86,0,0,0-.658-.072.84.84,0,0,0-.506.406.857.857,0,0,0,.33,1.168l2.542,1.423-2.34-.785a.856.856,0,0,0-.658.047.845.845,0,0,0-.428.49.864.864,0,0,0,.536,1.09l2.7.908-.354.1a.858.858,0,0,0-.614,1l.221,1.079L57.244,8.986,56.627,6.8l.026,0A6.51,6.51,0,0,0,58.2,6.607a.859.859,0,0,0-.416-1.667,4.437,4.437,0,0,1-2.467-.069,8.325,8.325,0,0,1-2.347-1.234.839.839,0,0,0-.639-.145.857.857,0,0,0-.352,1.544A9.928,9.928,0,0,0,54.761,6.5l.545,1.939-1.912,2.515-.066-.041a7.187,7.187,0,1,0,3.437,8.446l.042-.162,1.393.191L60.6,21.9l-.4.452a.862.862,0,0,0,.616,1.428.86.86,0,0,0,.671-.289l1.873-2.121a.859.859,0,1,0-1.287-1.137l-.334.378-1.618-1.7L67.5,11.039l.089.43a.748.748,0,0,0,.033.121l-.678.557a7.181,7.181,0,1,0,5.078-2.109m-3.431-6.41c-.012-.023-.024-.046-.037-.068l.374.21-.329.686-.056.015a.9.9,0,0,0,.091-.187.852.852,0,0,0-.043-.656M54.942,19.353a5.469,5.469,0,1,1-5.041-7.6,5.363,5.363,0,0,1,2.113.427l.317.172-3.393,4.473A.859.859,0,0,0,49.5,18.2l5.562.755Zm.424-2.087-4.174-.57,2.548-3.361.028.023a5.438,5.438,0,0,1,1.6,3.848Zm1.8-1.463a.84.84,0,0,0-.267-.181l-.137-.535a7.242,7.242,0,0,0-1.8-2.952l-.194-.16L55.891,10.5l1.583,5.622Zm2.346,1.237-1.8-6.4,9.3-2,.07.343Zm12.509,5.653a5.471,5.471,0,0,1-3.88-9.322l.3-.244.373.686-.293.234a5.29,5.29,0,0,0-1.183,1.708.856.856,0,0,0,.441,1.131.979.979,0,0,0,.329.075.868.868,0,0,0,.8-.515,3.581,3.581,0,0,1,.74-1.1l1.5,2.77a.867.867,0,0,0,.72.449.8.8,0,0,0,.118-.006.879.879,0,0,0,.322-.1.858.858,0,0,0,.348-1.162L71.084,14.41a.869.869,0,0,0,.3-1.038.858.858,0,0,0-.475-.461.843.843,0,0,0-.633,0l-.389-.72.009,0a5.4,5.4,0,0,1,2.128-.434,5.469,5.469,0,1,1,0,10.937"
                            transform="translate(-22.369 0)"
                            fill="#fff"
                          />
                          <path
                            id="Path_2149"
                            dataname="Path 2149"
                            d="M52.052,27.818a.848.848,0,0,0-.006-.662.839.839,0,0,0-.457-.459.857.857,0,0,0-.662,0A5.367,5.367,0,0,0,48,29.534a.867.867,0,0,0,.767,1.205h.024a.845.845,0,0,0,.781-.515,3.666,3.666,0,0,1,2.019-1.946.836.836,0,0,0,.461-.462"
                            transform="translate(-25.096 -13.945)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </article>
              </div>
              <div className="col-4">
                <p className="lufga-medium font-15 mt-5 prExtraSmall">
                  European cover
                </p>
              </div>

              <div className="col-2">
                <article className="bikeBucket mb-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="135"
                    height="135"
                    viewBox="0 0 135 135"
                    className="CoreIcon"
                  >
                    <defs>
                      <filter
                        id="Rectangle_748"
                        x="0"
                        y="0"
                        width="135"
                        height="135"
                        filterUnits="userSpaceOnUse"
                      >
                        <feOffset dy="2" input="SourceAlpha" />
                        <feGaussianBlur stdDeviation="1.5" result="blur" />
                        <feFlood floodOpacity="0.2" />
                        <feComposite operator="in" in2="blur" />
                        <feComposite in="SourceGraphic" />
                      </filter>
                      <clipPath id="clipPath888">
                        <rect
                          id="Rectangle_972"
                          data-name="Rectangle 972"
                          width="69.557"
                          height="77.12"
                          fill="#fff"
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Group_1808"
                      data-name="Group 1808"
                      transform="translate(-401.5 -727.5)"
                    >
                      <g
                        id="Group_1795"
                        data-name="Group 1795"
                        transform="translate(0 55)"
                      >
                        <g id="Group_1789" data-name="Group 1789">
                          <g
                            transform="matrix(1, 0, 0, 1, 401.5, 672.5)"
                            filter="url(#Rectangle_748)"
                          >
                            <rect
                              id="Rectangle_748-2"
                              data-name="Rectangle 748"
                              width="126"
                              height="126"
                              rx="32"
                              transform="translate(4.5 2.5)"
                              fill="#00a8ff"
                            />
                          </g>
                        </g>
                        <g
                          id="Group_2186"
                          data-name="Group 2186"
                          transform="translate(434.222 699.44)"
                        >
                          <g
                            id="Group_2141"
                            data-name="Group 2141"
                            clipPath="url(#clipPath8)"
                            scale="2.2"
                          >
                            <path
                              id="Path_2157"
                              data-name="Path 2157"
                              d="M68.6,24.477a4.853,4.853,0,0,0-2.505-1.755l-15.878-4.8a4.822,4.822,0,0,0-3.715.4,4.773,4.773,0,0,0-1.764,1.7L37.8,31.51a66.375,66.375,0,0,1-8.9-3.976,4.033,4.033,0,0,0,.338-.309,14.063,14.063,0,0,0,3.923-9.707,13.816,13.816,0,0,0-.15-2.021L31.246,3.671a4.265,4.265,0,0,0-.5-1.462A4.355,4.355,0,0,0,29.21.612,4.187,4.187,0,0,0,24.921.569,4.239,4.239,0,0,0,22.81,4.23a4.161,4.161,0,0,0,.047.628l1.771,11.887a5.437,5.437,0,0,1,.058.785,5.52,5.52,0,0,1-1.31,3.549L18.569,24.55a7.96,7.96,0,0,0-2.7,1.2c-.123.084-.234.182-.352.272a8.18,8.18,0,0,0,.968-3.861,8.236,8.236,0,0,0-3.452-6.711l0-.007-.306-.2-.005,0-.3-.195,0,.007a8.192,8.192,0,0,0-4.166-1.138h0a8.233,8.233,0,0,0-6.916,3.753A8.2,8.2,0,0,0,0,22.146a8.236,8.236,0,0,0,3.754,6.917,8.2,8.2,0,0,0,4.476,1.33h0a8.3,8.3,0,0,0,3.876-.965,8.108,8.108,0,0,0,1.232-.824l-.483.85a8.351,8.351,0,0,0-1.09,4.2,10,10,0,0,0,.336,2.541l.26,10.443a14.02,14.02,0,0,0,4.414,9.9,1.495,1.495,0,1,0,2.043-2.182,10.985,10.985,0,0,1-3.469-7.789L15.09,35.944a1.532,1.532,0,0,0-.057-.367,7.054,7.054,0,0,1-.275-1.923,5.824,5.824,0,0,1,.175-1.439,4.962,4.962,0,0,1,.524-1.285L16.1,29.8a4.927,4.927,0,0,1,3.382-2.393,1.491,1.491,0,0,0,.588-.255l5.2-3.753a1.461,1.461,0,0,0,.231-.208,8.432,8.432,0,0,0,2.175-5.661,8.247,8.247,0,0,0-.091-1.225L25.812,4.416a1.24,1.24,0,0,1,.279-.985,1.263,1.263,0,0,1,.329-.277A1.232,1.232,0,0,1,26.839,3a1.126,1.126,0,0,1,.619.064,1.341,1.341,0,0,1,.833,1.043l1.761,11.825a10.957,10.957,0,0,1-2.963,9.206,1.083,1.083,0,0,1-.149.126l-1.684,1.217a1.495,1.495,0,0,0,.12,2.5,69.252,69.252,0,0,0,11.5,5.369,8.466,8.466,0,0,1,.868.372,1.5,1.5,0,0,0,1.942-.566l7.607-12.586a1.778,1.778,0,0,1,.661-.639,1.812,1.812,0,0,1,1.4-.151l15.878,4.8a1.893,1.893,0,0,1,.975.683,1.818,1.818,0,0,1,.365,1.073,1.7,1.7,0,0,1-.061.452,1.788,1.788,0,0,1-.652.965,1.812,1.812,0,0,1-1.079.362,1.766,1.766,0,0,1-.521-.077l-13.5-4.079a1.488,1.488,0,0,0-1.71.657L41.684,37.8a1.5,1.5,0,0,0-.154,1.194,5.457,5.457,0,0,1,.223,1.539c0,.082,0,.164-.005.244a1.5,1.5,0,0,0,1.413,1.56l11.16.589a1.795,1.795,0,0,1,1.666,1.441L59.253,60.7a1.863,1.863,0,0,1,.036.355,1.805,1.805,0,0,1-.4,1.13,1.791,1.791,0,0,1-1.041.628,1.815,1.815,0,0,1-.356.036h0A1.8,1.8,0,0,1,55.73,61.4L52.966,47.576a1.494,1.494,0,0,0-1.387-1.2l-8.832-.467a12.4,12.4,0,0,0-4.967.776,7.714,7.714,0,0,1-5.052.007,76.256,76.256,0,0,1-12.764-5.608,1.495,1.495,0,0,0-2.218,1.344l.1,4.081.365-.007v.009l-.365.005h.176l-.176,0a8.449,8.449,0,0,0,3.4,6.615L30.91,60.29a1.248,1.248,0,0,1,.377.449,1.271,1.271,0,0,1,.129.556,1.247,1.247,0,0,1-.245.74,1.259,1.259,0,0,1-.449.376,1.243,1.243,0,0,1-1.3-.116,1.527,1.527,0,0,0-.286-.166l-2.268-1a1.494,1.494,0,1,0-1.206,2.734l2.12.929a4.228,4.228,0,0,0,1.076.532,4.235,4.235,0,0,0,4.712-1.509,4.221,4.221,0,0,0,.832-2.519,4.233,4.233,0,0,0-1.715-3.407l-9.657-7.153a5.455,5.455,0,0,1-2.2-4.3L20.8,44.915a79.286,79.286,0,0,0,10.986,4.614,10.707,10.707,0,0,0,7.021-.034,9.5,9.5,0,0,1,3.783-.6l7.676.405L52.8,61.989a4.785,4.785,0,0,0,9.478-.935,4.829,4.829,0,0,0-.093-.941L58.917,43.78a4.788,4.788,0,0,0-4.439-3.84l-9.812-.518c-.027-.2-.061-.406-.1-.608L51,28.158,63.391,31.9a4.846,4.846,0,0,0,4.259-.756,4.793,4.793,0,0,0,1.741-2.568,4.715,4.715,0,0,0,.166-1.237,4.826,4.826,0,0,0-.96-2.863m-55.1-2.319a5.255,5.255,0,0,1-2.784,4.63,5.337,5.337,0,0,1-5.328-.232A5.193,5.193,0,0,1,3.605,24.62a5.248,5.248,0,0,1,.231-5.328,5.19,5.19,0,0,1,1.937-1.777A5.286,5.286,0,0,1,8.245,16.9h0a5.256,5.256,0,0,1,4.63,2.783,5.306,5.306,0,0,1,.616,2.475"
                              transform="translate(0 0)"
                              fill="#fff"
                            />
                            <path
                              id="Path_2158"
                              data-name="Path 2158"
                              d="M55.635,80.154l8.986,3.691a1.494,1.494,0,1,0,1.136-2.764L56.77,77.389a1.494,1.494,0,0,0-1.136,2.765"
                              transform="translate(-14.758 -20.846)"
                              fill="#fff"
                            />
                            <path
                              id="Path_2159"
                              data-name="Path 2159"
                              d="M62.251,92.606a1.5,1.5,0,0,0-1.495-1.494h-20a1.494,1.494,0,1,0,0,2.988h20a1.5,1.5,0,0,0,1.495-1.494"
                              transform="translate(-10.592 -24.579)"
                              fill="#fff"
                            />
                            <path
                              id="Path_2160"
                              data-name="Path 2160"
                              d="M74.222,93.981a1.5,1.5,0,0,0-2.051.51l-3.407,5.659a1.495,1.495,0,0,0,2.561,1.542l3.407-5.659a1.494,1.494,0,0,0-.51-2.051"
                              transform="translate(-18.492 -25.295)"
                              fill="#fff"
                            />
                            <path
                              id="Path_2161"
                              data-name="Path 2161"
                              d="M29.285,79.795a1.5,1.5,0,1,0,1.5,1.5,1.5,1.5,0,0,0-1.5-1.5"
                              transform="translate(-7.495 -21.526)"
                              fill="#fff"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </article>
              </div>
              <div className="col-4">
                <p className="lufga-medium font-15 mt-5 prExtraSmall">
                  Personal accident
                </p>
              </div>

              <p className="font-14 mb-5 coreExtraPadding">
                <span className="infoIconBlue ">{infoIcon} </span> All elements
                of our Performance policy can be{" "}
                <span className="blueFont">
                <HashLink
                  scroll={(el) =>
                    el.scrollIntoView({ behavior: "smooth", block: "start" })
                  }
                  to="/OurCoverLevels#CorePerformanceComparisonTable"
                >
                  found here
                </HashLink>
              </span>
                .
              </p>
              <CTAButton
                align="left"
                colour="green"
                CTAText="Get a quote"
                onClick={() => {
                  sessionStorage.removeItem("context");
                }}
                Url={`/get-a-quote${search}`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VelosurePerformance;
